import React,{useState, useEffect} from "react";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import "../CSS/Smdisplay.css";
import { InstagramEmbed } from "react-social-media-embed";

const Smdisplay=()=>{
    const [links, setLinks] = useState([]);
  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/get-links')
      .then(response => {
        setLinks(response.data.links);
        setTitles(response.data.titles);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

    return(
      <div className="scmedia" style={{ marginTop: "100px" }}>
      <h1 style={{ fontSize: "30px", textAlign: "center", color: "#853f91" }}>
        Our Viral Health Tips
      </h1>
      <div className="links-grids1">
        {links.map((link, index) => (
          <div key={index} className="link-item">
          <button className="title-button">{titles[index]}</button>
            <InstagramEmbed url={link} width={320} className="Instalinksdisplay"/>
          </div>
        ))}
      </div>
    </div>
    );
}

export default Smdisplay;
